import type { UseQueryOptions } from "@pinia/colada";

import type { LocaleMorpheus } from "@solvari/translations";

import { toSearchParams } from "@solvari/utils";

import { ziggy } from "@/shared/libs/ziggy";
import { kyCacheTags } from "~/shared/composables/useCacheTags.ts";
import { handleNuxtQuery } from "~/shared/libs/networkErrorHandling.ts";

type GeoProductFaq = App.Data.Api.V4.MainSite.GeoProductFaqData;

function useGeoProductFaqs(params: {
  geoProductCategorySlug: string;
  localeCode: LocaleMorpheus;
  municipalitySlug: string;
}) {
  return {
    key: () => ["api.v4.main-site.geo-product-faqs", params],
    query: handleNuxtQuery(() =>
      kyCacheTags
        .get(ziggy("api.v4.main-site.geo-product-faqs.index"), {
          searchParams: toSearchParams(params),
        })
        .json<GeoProductFaq[]>(),
    ),
    staleTime: 5 * 60 * 1000,
  } satisfies UseQueryOptions;
}

export { type GeoProductFaq, useGeoProductFaqs };
